exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".store-skeleton[data-v-66dd52b4]{position:relative;top:-5px}", ""]);

// exports
